import Settings from "./settings";
import Home from "./home";

export const Pages = {
	Settings,
	Home,
};
